import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

export type LoadingStateProps = {
  label?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

const SIZES = {
  sm: { wrapper: 'py-8', icon: 'h-5 w-5', text: 'text-xs' },
  md: { wrapper: 'py-16', icon: 'h-6 w-6', text: 'text-sm' },
  lg: { wrapper: 'py-24', icon: 'h-7 w-7', text: 'text-base' },
} as const;

/** Centered spinner + label. Use whenever a section/page is fetching data. */
export function LoadingState({
  label = 'Carregando...',
  size = 'md',
  className,
}: LoadingStateProps) {
  const sz = SIZES[size];
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        'flex flex-col items-center justify-center gap-3 text-muted-foreground',
        sz.wrapper,
        className,
      )}
    >
      <Loader2 className={cn('animate-spin text-primary/70', sz.icon)} />
      <span className={cn('font-medium', sz.text)}>{label}</span>
    </div>
  );
}
